<template>
  <div class="inv-section-header">
    <span class="icon-tile" :style="{ color: color, background: tileBg }">
      <InvIcon :name="icon" />
    </span>
    <div class="titles">
      <p class="title">{{ title }}</p>
      <p v-if="subtitle" class="subtitle">{{ subtitle }}</p>
    </div>
    <div class="trailing">
      <slot name="trailing" />
    </div>
  </div>
</template>

<script>
import InvIcon from "@/components/invest/InvIcon.vue";

export default {
  name: "InvestSectionHeader",
  components: { InvIcon },
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    // Accent colour for the icon; tile background is a 10% wash of it.
    color: { type: String, default: "#4E84FF" },
  },
  computed: {
    tileBg() {
      return this.hexToRgba(this.color, 0.1);
    },
  },
  methods: {
    hexToRgba(hex, alpha) {
      const h = (hex || "").replace("#", "");
      const r = parseInt(h.substring(0, 2), 16);
      const g = parseInt(h.substring(2, 4), 16);
      const b = parseInt(h.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};
</script>

<style lang="scss" scoped>
.inv-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.icon-tile {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  font-size: 20px;
}

.titles {
  flex: 1;
  min-width: 0;
}

.title {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #001240;
}

.subtitle {
  margin: 2px 0 0;
  font-size: 11px;
  font-weight: 400;
  color: #8791a7;
}

.trailing {
  flex-shrink: 0;
}
</style>
